module.exports = __webpack_public_path__ + "img/tool.bfdb38b1.svg";